import { BooleanInput, Edit, EditProps, FormDataConsumer, required, SaveButton, SimpleForm, SimpleFormProps, TextInput, Toolbar } from 'react-admin';
import { CustomEditor } from '../../components';


function SettingsToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton disabled={props.pristine || props.validating} />
    </Toolbar>
  );
}

export default function Settings(props: Partial<SimpleFormProps>) {
  return (
    <Edit {...props} id="me" title="Configurações">
      <SimpleForm toolbar={<SettingsToolbar />}>
        <BooleanInput fullWidth label="O agendamento de visitas à Fábrica está suspenso?" source="isScheduleSuspended" />

        <FormDataConsumer>
          {({ formData, ...rest}) => formData.isScheduleSuspended && (
            <>
              <TextInput
                fullWidth
                label="Forneça um título informativo sobre supensão das visitas"
                source="scheduleSuspendedTitle"
                validate={[required()]}
              />

              <CustomEditor
                tools={['Color', 'list']}
                fullWidth
                label="Descreva com mais detalhes o motivo da supensão das visitas"
                source="scheduleSuspendedDescription"
                validate={[required()]}
              />
            </>
          )}
        </FormDataConsumer>

        <CustomEditor
          tools={['Color', 'list']}
          fullWidth
          label="Orientações sobre o agendamento de visitas"
          source="scheduleOrientations"
          validate={[required()]}
        />
      </SimpleForm>
    </Edit>
  );
}
